import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../types';

const tryFetchLogInfoSelector = (state: AppState) => state.tryFetchLogInfo;

export const selectLogInfo = createSelector(tryFetchLogInfoSelector, state => {
  return state;
});
